<template>
<div class="thal-page">
  <nav2 :title="title+$t('bet2D.t_1')"></nav2>
  <div class="bet-center">
    <div class="bet-time">
      <div class="bet-time-text">{{ list_record.lottery_date }},{{ list_record.lottery_time }} {{$t('thalIndex.t_9')}}</div>
    </div>
    <div class="bet-time-close">{{$t('bet2D.t_2')}}{{ list_record.lottery_time }} </div>
    <div class="bet-list">
      <div class="bet-item">
        <div class="bet-item-block" v-for="(item,index) in list"  :key="index">
          <div class="bet-item-warp" :class="{'disable-color':item.expect_bet_limit==item.expect_bet_tally,'betColor':item.id_selected==true}" @click.stop="_bet_note(item.code,item.id,item.expect_bet_tally,item.expect_bet_limit,index)">
            <span>{{ item.code }}</span>
            <div class="bet-item-Progress" v-if="is_tally==1 && item.expect_bet_tally<item.expect_bet_limit"><el-progress :text-inside="true" :stroke-width="4" :percentage="(item.expect_bet_tally/item.expect_bet_limit)*100" define-back-color="#2C662E" color="#27F12E" status="exception"></el-progress></div>
          </div>
        </div>

      </div>
    </div>
  </div>
  <div class="bet-submit">
    <div class="bet-submit-item">
      <div class="bet-submit-luck" @click.stop="_luckNum">{{$t('bet2D.t_3')}}</div>
      <div class="bet-submit-luck" @click.stop="_fast_click(1)">{{$t('bet2D.t_4')}}</div>
      <div class="bet-submit-num">
        <div @click.stop="_amount_add('1')"><i class="el-icon-remove"></i></div>
        <div><input type="type" v-model="amount" @input="_input_amount"/></div>
        <div @click.stop="_amount_add('2')"><i class="el-icon-circle-plus"></i></div>
      </div>
    </div>
    <div class="bet-submit-note">
        <div class="bet-note-num"><span>{{$t('bet2D.t_5')}}</span><span>{{ noteNum }}</span></div>
        <div class="bet-note-amount"><span>{{$t('bet2D.t_6')}}</span><span>{{ totalAmount }}</span></div>
        <div class="submit-bet" @click.stop="_bet">{{$t('bet2D.t_7')}}</div>

    </div>
  </div>
<!--幸运号码-->
  <div class="bet-cover" v-if="is_luck">
    <div class="luck-num">
      <div class="bet-shortcut-title">{{$t('bet3D.t_12')}}<span @click.stop="_fast_click(3)"><i class="el-icon-circle-close"></i></span></div>
      <div class="luck-tit">{{luckNum}}</div>
    </div>
  </div>

<!--快捷键-->
  <div class="bet-cover" v-if="isFast==1">
    <div class="bet-shortcut">
      <div class="bet-shortcut-title">{{$t('bet2D.t_8')}}<span @click.stop="_fast_click(2)"><i class="el-icon-circle-close"></i></span></div>
      <div class="bet-shortcut-submit">
        <div class="bet-shortcut-text">
          <span class="bet-shortcut-textN2">{{$t('bet2D.t_9')}}-</span>
          <div class="bet-shortcut-right">
            <div><span v-for="(item,index) in submit" @click.stop="_shortcut_click(item.type)">{{item.title}}</span></div>
            <div><span v-for="(item,index) in submit2" @click.stop="_shortcut_click(item.type)">{{item.title}}</span></div>
          </div>
        </div>
        <div class="bet-shortcut-text">
          <span class="bet-shortcut-textN">{{$t('bet2D.t_19')}}-</span>
          <div class="bet-shortcut-whole">
            <div><span v-for="(item,index) in num" @click.stop="_shortcut_click('contain'+index)">{{item}}</span></div>
          </div>
        </div>
        <div class="bet-shortcut-text">
          <span class="bet-shortcut-textN">{{$t('bet2D.t_20')}}-</span>
          <div class="bet-shortcut-whole">
            <div><span v-for="(item,index) in num" @click.stop="_shortcut_click('ten'+index)">{{item}}</span></div>
          </div>
        </div>
        <div class="bet-shortcut-text">
          <span class="bet-shortcut-textN">{{$t('bet2D.t_21')}}-</span>
          <div class="bet-shortcut-whole">
            <div><span v-for="(item,index) in num" @click.stop="_shortcut_click('unit'+index)">{{item}}</span></div>
          </div>
        </div>
        <div class="bet-shortcut-text">
          <span class="bet-shortcut-textN">{{$t('bet2D.t_22')}}-</span>
          <div class="bet-shortcut-later">
            <div @click.stop="_shortcut_click('special0')"><span >07,18,24,35,69</span></div>
          </div>
        </div>
        <div class="bet-shortcut-text">
          <span class="bet-shortcut-textN">{{$t('bet2D.t_23')}}-</span>
          <div class="bet-shortcut-later">
            <div @click.stop="_shortcut_click('special1')"><span >70,81,42,53,96</span></div>
          </div>
        </div>
        <div class="bet-shortcut-text">
          <span class="bet-shortcut-textN">{{$t('bet2D.t_24')}}-</span>
          <div class="bet-shortcut-later">
            <div @click.stop="_shortcut_click('special2')"><span>05,16,27,38,49</span></div>
          </div>
        </div>
        <div class="bet-shortcut-text">
          <span class="bet-shortcut-textN">{{$t('bet2D.t_25')}}-</span>
          <div class="bet-shortcut-later">
            <div @click.stop="_shortcut_click('special3')"><span >50,61,72,83,94</span></div>
          </div>
        </div>
        <div class="bet-shortcut-text">
          <span class="bet-shortcut-textN">{{$t('bet2D.t_26')}}-</span>
          <div class="bet-shortcut-later">
            <div @click.stop="_shortcut_click('interval0')"><span>00-19</span></div>
            <div @click.stop="_shortcut_click('interval1')"><span>20-39</span></div>
            <div @click.stop="_shortcut_click('interval2')"><span>40-59</span></div>
            <div @click.stop="_shortcut_click('interval3')"><span>60-79</span></div>
            <div @click.stop="_shortcut_click('interval4')"><span>80-99</span></div>
          </div>
        </div>
      </div>
    </div>
  </div>
<!--  投注失败-->
  <div class="bet-cover" v-if="is_err">
    <div class="luck-num">
      <div class="bet-shortcut-title">{{$t('bet3D.t_13')}}<span @click.stop="_fast_click(4)"><i class="el-icon-circle-close"></i></span></div>
      <div class="err-list">
        <div>{{ $t('recordsBet.t_8') }}</div><div>{{$t('recordsBet.t_9')}}</div><div>{{ $t('bet3D.t_14') }}</div>
      </div>
      <div v-for="(item,index) in err_list" class="err-list">
        <div>{{item.number}}</div><div>{{item.bet}}</div><div style="color: #ff0000">{{item.error}}</div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
  import nav2 from '../THAL/navs'
    export default {
    components:{nav2},
        name: "bet2D",
      data(){
         return{
           isFast:0,
           submit:[
             {title:this.$t('bet2D.t_10'),type:'big'},
             {title:this.$t('bet2D.t_11'),type:'small'},
             {title:this.$t('bet2D.t_12'),type:'singular'},
             {title:this.$t('bet2D.t_13'),type:'even'},
           ],
           submit2:[
             {title:this.$t('bet2D.t_14'),type:'twoEven'},
             {title:this.$t('bet2D.t_15'),type:'evenSingular'},
             {title:this.$t('bet2D.t_16'),type:'singularEven'},
             {title:this.$t('bet2D.t_17'),type:'twoSingular'},
             {title:this.$t('bet2D.t_18'),type:'same'},
           ],
           num:[0,1,2,3,4,5,6,7,8,9],
           lottery_id:'',
           record_id:'',
           lottery_abbr:'',
           list:[],
           list_record:{},
           title:'',
           is_tally:0,
           amount:0,
           noteNum:0,
           totalAmount:0,
           isConfirm:false,
           luckNum:'',
           is_luck:false,
           err_list:[],
           is_err:false,
           shortcut_list: {
             big:[],
             small:[],
             even:[],
             singular:[],
             twoEven:[],
             evenSingular:[],
             singularEven:[],
             twoSingular:[],
             same:[],
             contain0:[],
             contain1:[],
             contain2:[],
             contain3:[],
             contain4:[],
             contain5:[],
             contain6:[],
             contain7:[],
             contain8:[],
             contain9:[],
             ten0:[],
             ten1:[],
             ten2:[],
             ten3:[],
             ten4:[],
             ten5:[],
             ten6:[],
             ten7:[],
             ten8:[],
             ten9:[],
             unit0:[],
             unit1:[],
             unit2:[],
             unit3:[],
             unit4:[],
             unit5:[],
             unit6:[],
             unit7:[],
             unit8:[],
             unit9:[],
             special0:[],
             special1:[],
             special2:[],
             special3:[],
             interval0:[],
             interval1:[],
             interval3:[],
             interval4:[],

           },
         }
      },
      created() {
        let that=this;
        let lottery_id=that.$route.query.lottery_id;

        if(lottery_id!='' && lottery_id!=undefined){
          that.lottery_id=lottery_id;
          that.title=that.$route.query.lottery_name;
          that.is_tally=that.$route.query.is_tally;
          if(that.$route.query.record_id!='' && that.$route.query.record_id!=undefined){
            that.record_id=that.$route.query.record_id;
            that._record();

          }else{

          }

        }

      },
      methods:{
        _luckNum:function (){
          this.luckNum='';
          let rand = Math.floor(Math.random()*this.list.length);
          let rValue = this.list[rand];
          this.luckNum=rValue.code;
          this.is_luck=true;
        },
        _amount_add:function (m){
          let _self=this;
          if(m==1){
            if(parseFloat(_self.amount)>0){
              _self.amount=parseFloat(_self.amount)-1;
            }
          }else if(m==2){
            _self.amount=parseFloat(_self.amount)+1;
          }
          _self._total_amount();

        },
        _record:function (){
          let _self=this;
          this._PublicFun.getData('2', 'get', 'lottery/section/'+_self.lottery_id, {}, function (result) {
            if(result.data['status_code']==200){
              let list=result.data['data'];
              if(list.length>0){
                if(_self.record_id!=''){
                  for(var i=0;i<list.length;i++){
                    let stop_buy_time=list[i].stop_buy_time;
                    let timearr=stop_buy_time.replace(" ", ":").replace(/\\:/g, "-").split(":");
                    list[i].lottery_time=timearr[1]+':'+timearr[2];
                    if(list[i].record_id==_self.record_id){
                      _self.list_record=list[i];
                      _self._lottery();
                    }
                  }
                }else{
                  _self.list_record=list[0];
                  _self.$router.back();

                }
              }else{
                _self.$router.back();
              }


            }else{
              Toast(result.data['message']);
              _self.$router.back();
            }

          })
        },
        _bet_note(id,code,expect_bet_tally,expect_bet_limit,index){
           let _self=this;
           if(_self.is_tally==1 && parseFloat(expect_bet_tally)<parseFloat(expect_bet_limit)){
             if(_self.list[index].id_selected==true){
               _self.list[index].id_selected=false;
             }else{
               _self.list[index].id_selected=true;
             }

           }else{
             _self.list[index].id_selected=false;
           }
           _self.$forceUpdate();
          _self._total_amount();
        },
        _input_amount:function (e){
          let _self=this;
          if(parseFloat(e.target.value)>0){
            _self.amount=e.target.value;
          }
          _self._total_amount();
        },
        _total_amount:function (){
          let _self=this;
          let num=0;
          for(var i=0;i<_self.list.length;i++){
            if(_self.list[i].id_selected==true){
              num=parseFloat(num)+1;
            }
          }
          _self.noteNum=num;
          _self.totalAmount=_self._accMul(_self.noteNum,_self.amount);
        },
        _accMul:function (arg1,arg2){
          var m=0,s1=arg1.toString(),s2=arg2.toString();
          try
          {
            m+=s1.split(".")[1].length

          }
          catch(e)
          {}
          try
          {
            m+=s2.split(".")[1].length
          }
          catch(e)
          {}
          return Number(s1.replace(".",""))*Number(s2.replace(".",""))/Math.pow(10,m)
        },
        _bet:function(){
          let _self=this;
          let bets=[];
          if(parseFloat(_self.amount)>0){
            for(var i=0;i<_self.list.length;i++){
              if(_self.list[i].id_selected==true){
                let str={'playway_id':_self.list[i].playway_id,'bet':_self.amount};
                bets.push(str)
              }
            }
            if(bets.length>0){
              if(_self.isConfirm)
                return false;
              _self.isConfirm=true;
              bets=JSON.stringify(bets);
              this._PublicFun.getData('2', 'post', 'lottery/bet', {'lottery_id':_self.lottery_id,'record_id':_self.record_id,'bets':bets}, function (result) {
                if(result.data['status_code']==200){

                  _self.isConfirm=false;
                  _self.noteNum=0;
                  _self.totalAmount=0;
                  if(result.data['data'].length==0){
                    Toast(_self.$t('bet3D.t_8'));
                  }else{
                    _self.err_list=result.data['data'];
                    _self.is_err=true;
                  }
                  _self._lottery();
                }else{
                  Toast(result.data['message']);
                  _self.isConfirm=false;
                }

              })
            }else{
              Toast(_self.$t('bet3D.t_15'))
            }
          }else{
            Toast(_self.$t('bet3D.t_7'))
          }

        },
         _lottery:function (){
           let _self=this;
           this._PublicFun.getData('2', 'get', 'lottery/playway/'+_self.lottery_id+'/'+_self.record_id, {}, function (result) {
             if(result.data['status_code']==200){
               _self.list=result.data['data'];
               for(var i=0;i<_self.list.length;i++){
                 _self.list[i].id_selected=false;
               }
               _self.$forceUpdate();
               _self._Shortcut();
             }else{
               _self.$router.back();
             }

           })

         },
        /*快捷点*/
         _Shortcut:function (){
          let _self=this;
          _self.shortcut_list.even=_self._even('even');/*双*/
          _self.shortcut_list.singular=_self._even('singular');/*单*/
          _self.shortcut_list.twoEven=_self._even('twoEven');/*双双*/
          _self.shortcut_list.evenSingular=_self._even('evenSingular');/*双单*/
          _self.shortcut_list.singularEven=_self._even('singularEven');/*单双*/
          _self.shortcut_list.twoSingular=_self._even('twoSingular');/*单单*/
          _self.shortcut_list.same=_self._even('same') ;
          _self.shortcut_list.big=_self._even('big')/*大*/
          _self.shortcut_list.small=_self._even('small')/*小*/
          ;/*包含*/
           _self.shortcut_list.contain0=_self._even('contain0');
           _self.shortcut_list.contain1=_self._even('contain1');
           _self.shortcut_list.contain2=_self._even('contain2');
           _self.shortcut_list.contain3=_self._even('contain3');
           _self.shortcut_list.contain4=_self._even('contain4');
           _self.shortcut_list.contain5=_self._even('contain5');
           _self.shortcut_list.contain6=_self._even('contain6');
           _self.shortcut_list.contain7=_self._even('contain7');
           _self.shortcut_list.contain8=_self._even('contain8');
           _self.shortcut_list.contain9=_self._even('contain9');
           /*十位*/
           _self.shortcut_list.ten0=_self._even('ten0');
           _self.shortcut_list.ten1=_self._even('ten1');
           _self.shortcut_list.ten2=_self._even('ten2');
           _self.shortcut_list.ten3=_self._even('ten3');
           _self.shortcut_list.ten4=_self._even('ten4');
           _self.shortcut_list.ten5=_self._even('ten5');
           _self.shortcut_list.ten6=_self._even('ten6');
           _self.shortcut_list.ten7=_self._even('ten7');
           _self.shortcut_list.ten8=_self._even('ten8');
           _self.shortcut_list.ten9=_self._even('ten9');
           /*个位*/
           _self.shortcut_list.unit0=_self._even('unit0');
           _self.shortcut_list.unit1=_self._even('unit1');
           _self.shortcut_list.unit2=_self._even('unit2');
           _self.shortcut_list.unit3=_self._even('unit3');
           _self.shortcut_list.unit4=_self._even('unit4');
           _self.shortcut_list.unit5=_self._even('unit5');
           _self.shortcut_list.unit6=_self._even('unit6');
           _self.shortcut_list.unit7=_self._even('unit7');
           _self.shortcut_list.unit8=_self._even('unit8');
           _self.shortcut_list.unit9=_self._even('unit9');
           /*特别号*/
           _self.shortcut_list.special0=_self._even('special0');
           _self.shortcut_list.special1=_self._even('special1');
           _self.shortcut_list.special2=_self._even('special2');
           _self.shortcut_list.special3=_self._even('special3');
           /*区间*/
           _self.shortcut_list.interval0=_self._even('interval0');
           _self.shortcut_list.interval1=_self._even('interval1');
           _self.shortcut_list.interval2=_self._even('interval2');
           _self.shortcut_list.interval3=_self._even('interval3');
           _self.shortcut_list.interval4=_self._even('interval4');
         },
        _shortcut_click:function (type){
          let _self=this;
          let list=_self.shortcut_list[''+type+''];
          for(var i=0;i<_self.list.length;i++){
            for(var a=0;a<list.length;a++){
              if(list[a].playway_id==_self.list[i].playway_id){
                _self.list[i].id_selected=true;
              }
            }
          }

          _self.$forceUpdate();
        },
         _even:function (obj){
          let arr=this.list;
          let _self=this;
          let result=[];
          if(obj=='even'){
            arr.filter((item,index)=>{
              if(parseInt(item.code) % 2 ===0 && item.expect_bet_tally<item.expect_bet_limit){
                result.push(item)
              }
            })
          }else if(obj=='singular'){
            arr.filter((item,index)=>{
              if(parseInt(item.code) % 2 ===1 && item.expect_bet_tally<item.expect_bet_limit){
                result.push(item)
              }

            })
          }else if(obj=='twoEven'){
            arr.filter((item,index)=>{
              if(parseInt(item.code[0]) % 2 ===0 && parseInt(item.code[1]) % 2===0 && item.expect_bet_tally<item.expect_bet_limit){
                result.push(item)
              }

            })
          }else if(obj=='evenSingular'){
            arr.filter((item,index)=>{
              if(parseInt(item.code[0])  % 2 ===0 && parseInt(item.code[1])  % 2 ===1 && item.expect_bet_tally<item.expect_bet_limit){
                result.push(item)
              }

            })
          }else if(obj=='singularEven'){
            arr.filter((item,index)=>{
              if(parseInt(item.code[0])  % 2 ===1 && parseInt(item.code[1])  % 2 ===0 && item.expect_bet_tally<item.expect_bet_limit){
                result.push(item)
              }

            })
          }else if(obj=='twoSingular'){
            arr.filter((item,index)=>{
              if(parseInt(item.code[0]) % 2 ===1 && parseInt(item.code[1]) % 2===1 && item.expect_bet_tally<item.expect_bet_limit){
                result.push(item)
              }

            })
          }else if(obj=='same'){
            arr.filter((item,index)=>{
              if(parseInt(item.code[0]) === parseInt(item.code[1]) && item.expect_bet_tally<item.expect_bet_limit){
                result.push(item)
              }

            })
          }else if(obj=='big'){
            arr.filter((item,index)=>{
              if(parseInt(item.code) >49 && item.expect_bet_tally<item.expect_bet_limit){
                result.push(item)
              }
            })
          }else if(obj=='small'){
            arr.filter((item,index)=>{
              if(parseInt(item.code) <=49 && item.expect_bet_tally<item.expect_bet_limit){
                result.push(item)
              }
            })
          }else if(obj=='contain0'){
            arr.filter((item,index)=>{
              if(item.code.indexOf('0') !=-1 && item.expect_bet_tally<item.expect_bet_limit){
                result.push(item)
              }
            })
          }else if(obj=='contain1'){
            arr.filter((item,index)=>{
              if(item.code.indexOf('1') !=-1 && item.expect_bet_tally<item.expect_bet_limit){
                result.push(item)
              }
            })
          }else if(obj=='contain2'){
            arr.filter((item,index)=>{
              if(item.code.indexOf('2') !=-1 && item.expect_bet_tally<item.expect_bet_limit){
                result.push(item)
              }
            })
          }else if(obj=='contain3'){
            arr.filter((item,index)=>{
              if(item.code.indexOf('3') !=-1 && item.expect_bet_tally<item.expect_bet_limit){
                result.push(item)
              }
            })
          }else if(obj=='contain4'){
            arr.filter((item,index)=>{
              if(item.code.indexOf('4') !=-1 && item.expect_bet_tally<item.expect_bet_limit){
                result.push(item)
              }
            })
          }else if(obj=='contain5'){
            arr.filter((item,index)=>{
              if(item.code.indexOf('5') !=-1 && item.expect_bet_tally<item.expect_bet_limit){
                result.push(item)
              }
            })
          }else if(obj=='contain6'){
            arr.filter((item,index)=>{
              if(item.code.indexOf('6') !=-1 && item.expect_bet_tally<item.expect_bet_limit){
                result.push(item)
              }
            })
          }else if(obj=='contain7'){
            arr.filter((item,index)=>{
              if(item.code.indexOf('7') !=-1 && item.expect_bet_tally<item.expect_bet_limit){
                result.push(item)
              }
            })
          }else if(obj=='contain8'){
            arr.filter((item,index)=>{
              if(item.code.indexOf('8') !=-1 && item.expect_bet_tally<item.expect_bet_limit){
                result.push(item)
              }
            })
          }else if(obj=='contain9'){
            arr.filter((item,index)=>{
              if(item.code.indexOf('9') !=-1 && item.expect_bet_tally<item.expect_bet_limit){
                result.push(item)
              }
            })
          }else if(obj=='ten0'){
            arr.filter((item,index)=>{
              if(item.code[0].indexOf('0') !=-1 && item.expect_bet_tally<item.expect_bet_limit){
                result.push(item)
              }
            })
          }else if(obj=='ten1'){
            arr.filter((item,index)=>{
              if(item.code[0].indexOf('1') !=-1 && item.expect_bet_tally<item.expect_bet_limit){
                result.push(item)
              }
            })
          }else if(obj=='ten2'){
            arr.filter((item,index)=>{
              if(item.code[0].indexOf('2') !=-1 && item.expect_bet_tally<item.expect_bet_limit){
                result.push(item)
              }
            })
          }else if(obj=='ten3'){
            arr.filter((item,index)=>{
              if(item.code[0].indexOf('3') !=-1 && item.expect_bet_tally<item.expect_bet_limit){
                result.push(item)
              }
            })
          }else if(obj=='ten4'){
            arr.filter((item,index)=>{
              if(item.code[0].indexOf('4') !=-1 && item.expect_bet_tally<item.expect_bet_limit){
                result.push(item)
              }
            })
          }else if(obj=='ten5'){
            arr.filter((item,index)=>{
              if(item.code[0].indexOf('5') !=-1 && item.expect_bet_tally<item.expect_bet_limit){
                result.push(item)
              }
            })
          }else if(obj=='ten6'){
            arr.filter((item,index)=>{
              if(item.code[0].indexOf('6') !=-1 && item.expect_bet_tally<item.expect_bet_limit){
                result.push(item)
              }
            })
          }else if(obj=='ten7'){
            arr.filter((item,index)=>{
              if(item.code[0].indexOf('7') !=-1 && item.expect_bet_tally<item.expect_bet_limit){
                result.push(item)
              }
            })
          }else if(obj=='ten8'){
            arr.filter((item,index)=>{
              if(item.code[0].indexOf('8') !=-1 && item.expect_bet_tally<item.expect_bet_limit){
                result.push(item)
              }
            })
          }else if(obj=='ten9'){
            arr.filter((item,index)=>{
              if(item.code[0].indexOf('9') !=-1 && item.expect_bet_tally<item.expect_bet_limit){
                result.push(item)
              }
            })
          }else if(obj=='unit0'){
            arr.filter((item,index)=>{
              if(item.code[1].indexOf('0') !=-1 && item.expect_bet_tally<item.expect_bet_limit){
                result.push(item)
              }
            })
          }else if(obj=='unit1'){
            arr.filter((item,index)=>{
              if(item.code[1].indexOf('1') !=-1 && item.expect_bet_tally<item.expect_bet_limit){
                result.push(item)
              }
            })
          }else if(obj=='unit2'){
            arr.filter((item,index)=>{
              if(item.code[1].indexOf('2') !=-1 && item.expect_bet_tally<item.expect_bet_limit){
                result.push(item)
              }
            })
          }else if(obj=='unit3'){
            arr.filter((item,index)=>{
              if(item.code[1].indexOf('3') !=-1 && item.expect_bet_tally<item.expect_bet_limit){
                result.push(item)
              }
            })
          }else if(obj=='unit4'){
            arr.filter((item,index)=>{
              if(item.code[1].indexOf('4') !=-1 && item.expect_bet_tally<item.expect_bet_limit){
                result.push(item)
              }
            })
          }else if(obj=='unit5'){
            arr.filter((item,index)=>{
              if(item.code[1].indexOf('5') !=-1 && item.expect_bet_tally<item.expect_bet_limit){
                result.push(item)
              }
            })
          }else if(obj=='unit6'){
            arr.filter((item,index)=>{
              if(item.code[1].indexOf('6') !=-1 && item.expect_bet_tally<item.expect_bet_limit){
                result.push(item)
              }
            })
          }else if(obj=='unit7'){
            arr.filter((item,index)=>{
              if(item.code[1].indexOf('7') !=-1 && item.expect_bet_tally<item.expect_bet_limit){
                result.push(item)
              }
            })
          }else if(obj=='unit8'){
            arr.filter((item,index)=>{
              if(item.code[1].indexOf('8') !=-1 && item.expect_bet_tally<item.expect_bet_limit){
                result.push(item)
              }
            })
          }else if(obj=='unit9'){
            arr.filter((item,index)=>{
              if(item.code[1].indexOf('9') !=-1 && item.expect_bet_tally<item.expect_bet_limit){
                result.push(item)
              }
            })
          }else if(obj=='special0'){
            arr.filter((item,index)=>{
              if(item.code=='07' && item.expect_bet_tally<item.expect_bet_limit || item.code=='18' && item.expect_bet_tally<item.expect_bet_limit || item.code=='24' && item.expect_bet_tally<item.expect_bet_limit || item.code=='35' && item.expect_bet_tally<item.expect_bet_limit || item.code=='69' && item.expect_bet_tally<item.expect_bet_limit){
                result.push(item)
              }
            })
          }else if(obj=='special1'){
            arr.filter((item,index)=>{
              if(item.code=='70' && item.expect_bet_tally<item.expect_bet_limit || item.code=='81' && item.expect_bet_tally<item.expect_bet_limit || item.code=='42' && item.expect_bet_tally<item.expect_bet_limit || item.code=='53' && item.expect_bet_tally<item.expect_bet_limit || item.code=='96' && item.expect_bet_tally<item.expect_bet_limit){
                result.push(item)
              }
            })
          }else if(obj=='special2'){
            arr.filter((item,index)=>{
              if(item.code=='05' && item.expect_bet_tally<item.expect_bet_limit || item.code=='16' && item.expect_bet_tally<item.expect_bet_limit || item.code=='27' && item.expect_bet_tally<item.expect_bet_limit || item.code=='38' && item.expect_bet_tally<item.expect_bet_limit || item.code=='49' && item.expect_bet_tally<item.expect_bet_limit){
                result.push(item)
              }
            })
          }else if(obj=='special3'){
            arr.filter((item,index)=>{
              if(item.code=='50' && item.expect_bet_tally<item.expect_bet_limit || item.code=='61' && item.expect_bet_tally<item.expect_bet_limit || item.code=='72' && item.expect_bet_tally<item.expect_bet_limit  || item.code=='83' && item.expect_bet_tally<item.expect_bet_limit || item.code=='94' && item.expect_bet_tally<item.expect_bet_limit){
                result.push(item)
              }
            })
          }else if(obj=='interval0'){
            arr.filter((item,index)=>{
              if( parseFloat(item.code)<=19 && item.expect_bet_tally<item.expect_bet_limit){
                result.push(item)
              }
            })
          }else if(obj=='interval1'){
            arr.filter((item,index)=>{
              if( parseFloat(item.code)>19 && parseFloat(item.code)<=39 && item.expect_bet_tally<item.expect_bet_limit){
                result.push(item)
              }
            })
          }else if(obj=='interval2'){
            arr.filter((item,index)=>{
              if( parseFloat(item.code)>39 && parseFloat(item.code)<=59 && item.expect_bet_tally<item.expect_bet_limit){
                result.push(item)
              }
            })
          }else if(obj=='interval3'){
            arr.filter((item,index)=>{
              if( parseFloat(item.code)>59 && parseFloat(item.code)<=79 && item.expect_bet_tally<item.expect_bet_limit){
                result.push(item)
              }
            })
          }else if(obj=='interval4'){
            arr.filter((item,index)=>{
              if( parseFloat(item.code)>79 && parseFloat(item.code)<=99 && item.expect_bet_tally<item.expect_bet_limit){
                result.push(item)
              }
            })
          }
           return result

         },
        _fast_click:function (m) {
           let that=this;
           if(m==1){
             that.isFast=1;
           }else if(m==2){
             that.isFast=0
           }else if(m==3){
             that.is_luck=false;
           }else if(m==4){
             that.is_err=false;
           }
         }
      }
    }
</script>

<style scoped>
  .bet-center{
    display: block;
    width: 100%;
    margin: 65px auto 80px;
    max-width: 750px;
  }
  .bet-time{
    display: flex;
    align-items: center;
    width:94%;
    margin: 0 auto;
    padding: 0;
    position: relative;
  }
  .bet-time-text{
    color: #BCBCBC;
    /*font-size: 10px;*/
  }
  .bet-time :after{
    position: absolute;
    content: '';
    left: 220px;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    border-bottom: 1px solid #BCBCBC;
  }
  .bet-time-close{
    display: block;
    text-align: right;
    width: 94%;
    color: #ff0000;
  }
  .bet-list{
    display: block;
    width: 94%;
    margin: 0 auto;
    padding: 0;
  }
  .bet-item{
    display: block;
    width: 100%;
    margin: 0 auto;
    padding: 0;
    clear: both;
  }
  .bet-item-block{
    display: block;
    width: 14.28%;
    margin: 0;
    padding: 0;
    float: left;
    text-align: center;
  }
  .bet-item-warp{
    display: flex;
    align-items: center;
    justify-content: center;
    width: 35px;
    margin: 3px auto;
    font-weight: bolder;
    color: #F4D788;
    position: relative;
    height: 40px;
    cursor: pointer;
    font-size: 15px;
    border-radius: 5px;
    border: 1px solid #F4D788;
  }
  .bet-item-Progress{
    position: absolute;
    bottom: 10px;
    width: 80%;
    left: 50%;
    height: 5px;
    transform: translateX(-50%);
  }
  .betColor{
    background-color: #EDD185 !important;
    color: #000000 !important;
    border: 1px solid #EDD185;
  }
  .betColor .bet-item-Progress{
    opacity: 0.5;
  }
  .disable-color{
    border: 1px solid #7C7C7C !important;
    color: #7C7C7C !important;

  }
  .bet-submit{
    position: fixed;
    z-index: 9;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    bottom: 0;
    background-color: #E8BD70;
    height: 80px;
    max-width: 750px;
  }
  .bet-submit-item{
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 96%;
    margin: 5px auto;
    padding: 0;
  }
  .bet-submit-luck{
    display: block;
    width: 27%;
    text-align: center;
    margin: 0;
    background-color: #2D2D2D;
    line-height: 25px;
    border-radius: 5px;
    font-size: 12px;
    color: #E8BD70;
    cursor: pointer;
  }
  .bet-submit-num{
    display: flex;
    align-items: center;
    width: 44%;
    justify-content: space-between;
  }
  .bet-submit-num div:first-child,.bet-submit-num div:last-child{
    font-size: 22px;
    cursor: pointer;
  }
  .bet-submit-num div:nth-child(2){
    display: block;
    width: 100%;

  }
  .bet-submit-num div:nth-child(2) input{
    display: block;
    width: 90%;
    margin: 0 auto;
    border: 1px solid #2D2D2D;
    height: 25px;
    line-height: 25px;
    text-align: center;
    font-weight: bold;
    outline: none;
    border-radius: 5px;
    background-color: transparent;
  }
  .bet-submit-note{
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 96%;
    margin:0 auto;
    padding: 0;
    font-size: 12px;
  }
  .bet-note-num,.bet-note-amount{
    display: flex;
    align-items: center;
  }
  .bet-note-amount{
    width: 55%;
    justify-content: center;
  }
  .bet-note-num span:last-child{
    border: 1px solid #2D2D2D;
    width: 35px;
    height: 25px;
    color: #2D2D2D;
    line-height: 25px;
    border-radius: 5px;
    text-align: center;
  }
  .bet-note-amount span:last-child{
    display: block;
    width: 65%;
    height:25px;
    padding: 0 3px;
    line-height: 25px;
    text-align: right;
    border: 1px solid #2D2D2D;
    border-radius: 5px;
  }
  .submit-bet{
    display: block;
    width: 60px;
    height: 25px;
    border-radius: 5px;
    background-color: #2D2D2D;
    text-align: center;
    color: #E8BD70;
    line-height: 25px;
    cursor: pointer;
  }

  .bet-cover{
    position: fixed;
    z-index: 99;
    left: 0;
    width: 100%;
    top: 0;
    bottom: 0;
    background-color: rgba(0,0,0,0.5);
  }
  .bet-shortcut{
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    background-color: #2D2D2D;
  }
  .bet-shortcut-title{
    display: block;
    width: 100%;
    margin: 0 auto;
    padding: 10px 0;
    text-align: center;
    position: relative;
    color: #dddddd;
  }
  .bet-shortcut-title span{
    position: absolute;
    top: 50%;
    right: 10px;
    color: #E9CD83;
    font-size:28px;
    transform: translateY(-50%);
  }
  .bet-shortcut-submit{
    display: block;
    width: 96%;
    margin: 0 auto;
    padding: 0;
  }
  .bet-shortcut-text{
    display: flex;
    align-items: center;
    width: 100%;
    margin: 5px auto;
    position: relative;
    zoom: 0.7;
  }
  .bet-shortcut-textN{
    position: absolute;
    top: 50%;
    left: 0;
    color: #dddddd;
    transform: translateY(-50%);
  }
  .bet-shortcut-textN2{
    position: absolute;
    top: 12px;
    left: 0;
    color: #dddddd;
  }
  .bet-shortcut-right,.bet-shortcut-whole,.bet-shortcut-later{
    padding-left:70px;


  }
  .bet-shortcut-right div,.bet-shortcut-whole div{
    display: flex;
    align-items: center;
    width: 100%;
    margin: 0 auto;
    padding: 0;
  }
  .bet-shortcut-right div span{
    display: block;
    width: 40px;
    height: 40px;
    line-height: 40px;
    margin-bottom: 5px;
    text-align: center;
    border: 2px solid #E9CD83;
    border-radius: 5px;
    color: #E9CD83;
    margin-right: 5px;
  }
  .bet-shortcut-whole div span{
    height: 40px;
    width:28px;
    text-align: center;
    border: 2px solid #E9CD83;
    border-radius: 8px;
    margin-right: 5px;
    line-height: 40px;
    color: #E9CD83;
  }
  .bet-shortcut-later{
    display: flex;
  }
  .bet-shortcut-later div{
    display: flex;
    line-height: 40px;
    color: #E9CD83;
    margin-right: 5px;
    text-align: center;
    border-radius: 5px;
    padding: 0 10px;
    border: 2px solid #E9CD83;
  }
  .luck-num{
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    width: 80%;
    background-color: #FFFFFF;

  }
  .luck-num .bet-shortcut-title{
    color: #000000;
  }
  .luck-num .bet-shortcut-title span{
    color: #000000;
  }
  .luck-tit{
    display: block;
    width: 100%;
    margin: 0 auto;
    padding: 10px 0;
    text-align: center;
    font-weight: bold;
    font-size: 18px;
    color: #F6D989;
  }
  .err-list{
    display: flex;
    width: 96%;
    margin: 0 auto;
    padding: 5px 0;
    border-top: 1px solid #DCDCDC;
    font-size: 12px;
    color: #303133;

  }
  .err-list div{
    display: block;
    width: 50%;
    margin: 0 ;
    padding: 0;
    text-align: center;
  }

</style>



// WEBPACK FOOTER //
// src/components/THAL/bet2D.vue